



















































































































































































































































































import Vue from "vue";

// Typescript Files
import * as Api from "@/axios-generated/backoffice/index";

import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BAvatar,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import { required } from "@validations";
import useProductsCreate from "./useProductsCreate";

export default Vue.extend({
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BAvatar,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
  },
  data() {
    return {
      required,
      publicPath: process.env.BASE_URL,
      categoryOptions: [
        { value: "select_value", text: "Select Value" },
        {
          value: Api.ProductCategoryEnum.Saas,
          text: Api.ProductCategoryEnum.Saas,
        },
        {
          value: Api.ProductCategoryEnum.Api,
          text: Api.ProductCategoryEnum.Api,
        },
      ],
      statusOptions: [
        { value: "select_value", text: "Select Value" },
        {
          value: Api.ProductStatusEnum.Created,
          text: Api.ProductStatusEnum.Created,
        },
        {
          value: Api.ProductStatusEnum.Enabled,
          text: Api.ProductStatusEnum.Enabled,
        },
        {
          value: Api.ProductStatusEnum.Suspended,
          text: Api.ProductStatusEnum.Suspended,
        },
        {
          value: Api.ProductStatusEnum.Disabled,
          text: Api.ProductStatusEnum.Disabled,
        },
      ],
    };
  },
  props: {
    newProduct: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { createProduct } = useProductsCreate();

    const productImageOptions = require
      .context("/public/images/products", true, /^.*\.png$/)
      .keys()
      .map((val) => val.replace("./", ""));

    return {
      createProduct,
      productImageOptions,
    };
  },
  methods: {
    submitForm(createProduct) {
      this.$bvModal
        .msgBoxConfirm("Voulez-vous confirmer l'opération ?", {
          size: "sm",
          okVariant: "primary",
          okTitle: "Oui",
          cancelTitle: "Non",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.createProduct(createProduct);
          }
        });
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
  },
});
